
import HeaderText from './HeaderText'
import breakpointMixin from '~/mixins/breakpoints'
export default {
  components: {
    HeaderText,
  },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  computed: {
    component() {
      let componentType = null

      if (this.blok.type === 'text-h1 md:text-featured') componentType = 'h1'
      if (this.blok.type === 'text-h2 md:text-h1') componentType = 'h1'
      if (this.blok.type === 'text-h3 md:text-h2') componentType = 'h2'
      if (this.blok.type === 'text-h3') componentType = 'h3'
      if (this.blok.type === 'text-h4') componentType = 'h4'
      return componentType
    },
    containerStyles() {
      const styles = {}

      styles.maxWidth = this.getBreakpointValue(this.blok.maxWidth)
      styles.padding = this.getBreakpointValue(this.blok.padding)
      styles.margin = this.getBreakpointValue(this.blok.margin)
      styles.color = this.blok.textColorOverride

      return styles
    },
  },
}
